@import './root.less';

@import './scrollbar.less';

@import './tailwind.less';

@import './global.less';